let getTokenFn: (() => Promise<string>) | null = null;

export const authService = {
  setGetTokenFn: (fn: () => Promise<string>) => {
    getTokenFn = fn;
  },
  getTokenSilently: async () => {
    if (!getTokenFn) throw new Error('getTokenSilently function not set');
    return await getTokenFn();
  },
};
